export default {
  "title": "FreeDive Ai",
  "heroHeadline": "¡Entrena todos los días y mejora tus habilidades de apnea!",
  "heroSubheadline": "La aplicación definitiva de entrenamiento de apnea con IA para apneístas, pescadores submarinos y sirenas.",
  "featuresHeader": "¿Por qué elegir FreeDive Ai?",
  "featuresSubtitle": "Todo lo que necesitas para bucear más profundo, aguantar la respiración por más tiempo y mantenerte seguro.",
  "feature1Title": "Entrenamiento de Apnea con IA",
  "feature1Desc": "Tablas personalizadas de CO2 y O2 generadas por IA según tus mejores marcas personales para aumentar tus tiempos de apnea de forma segura.",
  "feature2Title": "Cuaderno de Bitácora Inteligente",
  "feature2Desc": "Registra tus sesiones de apnea y pesca submarina. Controla profundidades, tiempos, frecuencia cardíaca y SpO2 en un solo lugar.",
  "feature3Title": "Competiciones y Licencias",
  "feature3Desc": "Mantén un registro de tus licencias de apnea y mantente informado sobre competiciones y eventos globales.",
  "screenshotsTitle": "Capturas de pantalla",
  "copyright": "© DomiLabs. All rights reserved."
};
